const { hasOwnProperty } = Object.prototype;

export function upgradeProperties(instance, props = []) {
  if (!instance || !Array.isArray(props)) return;
  for (const prop of props) {
    if (prop && hasOwnProperty.call(instance, prop)) {
      const value = instance[prop];
      delete instance[prop];
      instance[prop] = value;
    }
  }
}

export function emitValueEvents(target, events = ['input', 'change']) {
  if (!target) return;
  for (const type of events) {
    if (!type) continue;
    target.dispatchEvent(new Event(type, { bubbles: true }));
  }
}
